import { useTranslation } from "react-i18next";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "./alert-dialog";
import { isValidElement, useState } from "react";

type CustomAlertDialogProps = {
  title?: React.ReactNode;
  description?: React.ReactNode | null;
  cancelButton?: React.ReactNode | null;
  confirmButton?: React.ReactNode;
  onConfirm?: () => void;
  onCancel?: () => void;
  children: React.ReactElement;
};

export const CustomAlertDialog = ({
  children,
  title,
  description,
  onConfirm,
  onCancel,
  cancelButton,
  confirmButton,
}: CustomAlertDialogProps) => {
  const { t } = useTranslation();
  const [open, onOpenChange] = useState(false);

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogTrigger asChild>{children}</AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle asChild={isValidElement(title)}>
            {isValidElement(title) ? (
              <>{title}</>
            ) : (
              t("common.alertDialog.title")
            )}
          </AlertDialogTitle>
          {description !== null && (
            <AlertDialogDescription asChild={isValidElement(description)}>
              {isValidElement(description) ? (
                <>{description}</>
              ) : (
                t("common.alertDialog.description")
              )}
            </AlertDialogDescription>
          )}
        </AlertDialogHeader>
        <AlertDialogFooter>
          {cancelButton !== null && (
            <AlertDialogCancel
              asChild={isValidElement(cancelButton)}
              onClick={onCancel}
            >
              {isValidElement(cancelButton) ? (
                <>{cancelButton}</>
              ) : (
                t("common.alertDialog.cancel")
              )}
            </AlertDialogCancel>
          )}
          {confirmButton !== null && (
            <AlertDialogAction
              onClick={onConfirm}
              asChild={isValidElement(confirmButton)}
            >
              {isValidElement(confirmButton) ? (
                <>{confirmButton}</>
              ) : (
                t("common.alertDialog.confirm")
              )}
            </AlertDialogAction>
          )}
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
